<template>
  <div id="register">
    <main>
      <van-form validate-first @failed="onfailed" @submit="submit">
        <!-- 品牌信息 -->
        <section>
          <img :src="$store.state.appInfo.appLogoUrl" alt="" />
          <p>{{ $store.state.appInfo.title }}</p>
        </section>

        <!-- 注册类型 -->
        <div class="register-type">
          <p @click="registerType = 0" :class="{ 'type--checked': !registerType }">账号注册</p>
          <span>- or -</span>
          <p @click="registerType = 1" :class="{ 'type--checked': registerType }">手机注册</p>
        </div>

        <van-field class="desc-cell" :left-icon="require('../assets/images/referrer.png')" v-model="user.referrerAgentCode" readonly>
          <template #button>
            <van-button size="small" type="primary" disabled>（推荐人）</van-button>
          </template>
        </van-field>

        <!-- 账号注册 -->
        <template v-if="!registerType">
          <van-field
            :left-icon="require('../assets/images/secret.png')"
            type="password"
            placeholder="请设置密码"
            v-model="user.password"
            :rules="[{ validator: pswRule, message: '密码必须6位及以上' }]"
          />
          <van-field
            :left-icon="require('../assets/images/secret.png')"
            type="password"
            placeholder="请确认密码"
            v-model="user.confirmPwd"
            :rules="[{ validator: cPswRule, message: '两次密码不一致!' }]"
          />
          <van-field
            class="img-cell"
            :left-icon="require('../assets/images/photo.png')"
            v-model="verifyCode"
            placeholder="请输入图片验证码"
            type="digit"
            :rules="[{ validator, message: '验证码不正确' }]"
          >
            <template #button>
              <van-button size="small" @click="changeImgCode">
                <image-captcha class="imgCode" :identifyCode="identifyCode"></image-captcha>
              </van-button>
            </template>
          </van-field>
        </template>

        <!-- 手机号码注册 -->
        <div v-else style="">
          <van-field
            :left-icon="require('../assets/images/phone.png')"
            name="pattern"
            type="tel"
            placeholder="请输入手机号码"
            v-model="user.mobile"
            :rules="[{ pattern, message: '手机号码格式错误' }]"
          />
          <van-field
            class="sms-cell"
            type="digit"
            :left-icon="require('../assets/images/photo.png')"
            placeholder="请输入短信验证码"
            v-model="user.validCode"
            right
            :rules="[{ required: true, message: '必填' }]"
          >
            <template #button>
              <van-button size="small" type="primary" native-type="button" @click="getSms">{{ time }}{{ smsMsg }}</van-button>
            </template>
          </van-field>
          <van-field
            :left-icon="require('../assets/images/secret.png')"
            type="password"
            placeholder="请设置密码"
            v-model="user.password"
            :rules="[{ validator: pswRule, message: '密码必须6位及以上' }]"
          />
          <van-field
            style="margin-bottom:10px"
            :left-icon="require('../assets/images/secret.png')"
            type="password"
            placeholder="请确认密码"
            v-model="user.confirmPwd"
            :rules="[{ validator: cPswRule, message: '两次密码不一致!' }]"
          />
        </div>

        <p>
          <img src="../assets/images/ellipse.png" alt="" v-show="!show" @click="agree" />
          <img src="../assets/images/check.png" alt="" v-if="show" @click="agree" />
          <span @click="agree">我已阅读并同意</span><span @click="agreement">《注册协议》</span>
        </p>
        <div class="button">
          <van-button block color="#2A3D80" :disabled="!show" native-type="submit">同意协议并注册</van-button>
          <div>
            <van-button block icon="share-o" color="#2A3D80" plain native-type="button" @click.native="goApplet">前往小程序</van-button>
            <van-button block icon="down" color="#2A3D80" plain native-type="button" @click.native="goDownload">下载App</van-button>
          </div>
        </div>
      </van-form>
    </main>
  </div>
</template>

<script>
import ImageCaptcha from '../components/ImageCaptcha'
import { register, getSmsCode, preValidMobile, getUrlScheme } from '../assets/js/http/api'
export default {
  name: 'Register',
  components: {
    ImageCaptcha
  },
  data() {
    return {
      pattern: /^1[3456789]\d{9}$/,
      identifyCodes: '1234567890',
      identifyCode: '',
      verifyCode: '',
      show: false,
      classValue: '',
      registerType: 0,
      user: {
        sourceType: 0,
        referrerAgentCode: this.$route.query.agentCode,
        payMarketMode: this.$route.query.payMarketMode,
        mobile: null,
        password: null,
        validCode: '',
        regType: 0,
        confirmPwd: ''
      },
      time: '',
      smsMsg: '获取验证码'
    }
  },
  watch: {
    registerType(val) {
      this.user.regType = val
    }
  },
  mounted() {
    this.changeImgCode()
  },
  methods: {
    async getSms() {
      if (this.smsMsg == '获取验证码') {
        if (!/^1[3456789]\d{9}$/.test(this.user.mobile)) {
          return this.$toast({
            forbidClick: true,
            overlay: true,
            message: '请正确填写手机号码！'
          })
        }
        const flag = await preValidMobile({ mobile: this.user.mobile })
        if (!flag.data.data.validFlag) {
          return this.$toast({
            message: '该手机号已存在！'
          })
        }
        const res = await getSmsCode({
          mobile: this.user.mobile,
          validateType: 5
        })

        if (res.data.code == '00') {
          this.time = 60
          this.smsMsg = 's后获取'
          var timer = setInterval(() => {
            this.time--
            if (this.time <= 0) {
              this.time = ''
              this.smsMsg = '获取验证码'
              clearInterval(timer)
            }
          }, 1000)
        }
      }
    },
    pswRule(val) {
      return /^\S{6,}$/.test(val)
    },
    cPswRule(val) {
      return this.user.password == val
    },
    validator(val) {
      return val == this.identifyCode
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    changeImgCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    agree() {
      this.show = !this.show
      if (this.show == true) {
        this.classValue = 'button-background-color'
      } else {
        this.classValue = 'gray'
      }
    },
    agreement() {
      this.$router.push('/agreement')
    },
    onfailed(err) {},
    submit() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '加载中...'
      })
      register(this.user)
        .then(res => {
          this.$toast.clear()
          if (res.data.code == '00') {
            const registerType = this.registerType
            const mobile = this.user.mobile
            const message = registerType ? `您的登录手机号为: ${mobile}` : `您的代理商编号为: ${res.data.data}`

            Object.assign(this.$data, this.$options.data.call(this))

            this.$dialog.alert({
              title: '注册成功',
              message: message + '\n请前往小程序或下载App登录！',
              showCancelButton: true,
              cancelButtonText: '关闭',
              confirmButtonText: '复制',
              confirmButtonColor: '#39b54a',
              beforeClose: (action, done) => {
                if (action == 'confirm') {
                  this.$copyText(registerType ? mobile : res.data.data).then(
                    e => {
                      this.$toast({
                        message: '复制成功！'
                      })
                    },
                    e => {
                      this.$toast({
                        message: '复制失败！'
                      })
                    }
                  )
                }
                done()
              }
            })
          } else {
            this.changeImgCode()
            this.$toast.fail({
              forbidClick: true,
              overlay: true,
              message: res.data.message
            })
          }
        })
        .catch(error => {
          this.$toast.fail({
            forbidClick: true,
            overlay: true,
            message: '操作失败，请稍候重试！'
          })
        })
    },
    goDownload() {
      this.$router.push('/download')
    },
    async goApplet() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '请稍候...'
      })
      getUrlScheme()
        .then(res => {
          this.$toast.clear()
          if (res?.data?.data?.openlink) {
            location.href = res.data.data.openlink
          } else {
            this.$toast.fail({
              forbidClick: true,
              message: '获取链接异常！'
            })
          }
        })
        .catch(error => {
          this.$toast.fail({
            forbidClick: true,
            message: '操作失败，请稍候重试！'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
#register {
  > main {
    height: 100vh;
    padding-bottom: 15px;
    overflow-y: scroll;
    .van-form {
      > section {
        text-align: center;
        padding: 41px 0;
        > img {
          width: 60px;
        }
        > p {
          font-size: 15px;
          margin: 0;
        }
      }
      .register-type {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8799a3;
        font-size: 12px;
        > p {
          position: relative;
          margin: 0;
          &::after {
            content: '';
            position: absolute;
            top: -5px;
            right: -5px;
            bottom: -5px;
            left: -5px;
          }
        }
        > span {
          margin: 0 15px;
          font-size: 14px;
        }
      }
      .type--checked {
        font-size: 14px;
        color: #333;
        font-weight: bolder;
        animation: 1s flipInX;
      }
      .van-cell {
        width: 280px;
        background-color: #f3f5f7;
        border-radius: 5px;
        padding: 0;
        margin: 15px auto;
        animation: 1s flipInX;
        &::after {
          display: none;
        }
        /deep/ .van-field__left-icon {
          height: 44px;
          margin: 0;
          &::after {
            content: '';
            width: 1px;
            height: 16px;
            background-color: #666666;
            position: absolute;
            top: 14px;
            left: 40px;
          }
          .van-icon__image {
            width: 15px;
            height: 18px;
            margin: 13px;
          }
        }
        /deep/ .van-field__body {
          height: 44px;
          padding-left: 7px;
          .van-field__control {
            height: 100%;
          }
        }
      }
      .img-cell {
        margin-bottom: 10px;
      }
      .img-cell,
      .desc-cell {
        /deep/ .van-field__button {
          padding: 0;
          .van-button--small {
            font-size: 14px;
            color: #757575;
            background-color: rgba(0, 0, 0, 0);
            border: 1px solid rgba(0, 0, 0, 0);
            padding: 0;
            .imgCode {
              position: absolute;
              top: 0;
              right: 8px;
              #s-canvas {
                width: 64px;
                height: 29px;
                border-radius: 4px;
              }
            }
          }
        }
      }
      .sms-cell {
        padding-right: 8px;
        /deep/ .van-button--small {
          height: 28px;
        }
      }
      > p {
        color: #666666;
        position: relative;
        margin-top: 0;
        margin-left: 50px;
        > img {
          width: 12px;
        }
        > span {
          font-size: 12px;
          margin-left: 5px;
          position: relative;
          bottom: 2px;
          &:nth-of-type(2) {
            color: #004ea9;
          }
        }
      }
      .button {
        margin: 30px 45px 0;
        .van-button {
          // width: 285px;
          height: 44px;
          margin-bottom: 15px;
          border-radius: 5px;
        }

        > div {
          display: flex;
          align-items: center;
          .van-button {
            border-radius: 0;
            &:first-child {
              border-right: none;
            }
          }
        }
      }
    }
  }
}
.button-background-color {
  background-color: #004dab !important;
}
.gray {
  background-color: #757575;
}

@keyframes flipInX {
  from {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}
</style>
